var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 207,
    viewBox: "0 0 186 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.3271,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6562,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.9834,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.3115,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.64,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.968,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.296,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.624,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.951,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 20.3604,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.3271,
    y: 20.3604,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6562,
    y: 20.3604,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.9834,
    y: 20.3604,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.3115,
    y: 20.3604,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.64,
    y: 20.3604,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.968,
    y: 20.3604,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.296,
    y: 20.3604,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.624,
    y: 20.3604,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.951,
    y: 20.3604,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 40.7227,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.3271,
    y: 40.7227,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6562,
    y: 40.7227,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.9834,
    y: 40.7227,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.3115,
    y: 40.7227,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.64,
    y: 40.7227,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.968,
    y: 40.7227,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.296,
    y: 40.7227,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.624,
    y: 40.7227,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.951,
    y: 40.7227,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 61.0845,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.3271,
    y: 61.0845,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6562,
    y: 61.0845,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.9834,
    y: 61.0845,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.3115,
    y: 61.0845,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.64,
    y: 61.0845,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.968,
    y: 61.0845,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.296,
    y: 61.0845,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.624,
    y: 61.0845,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.951,
    y: 61.0845,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 81.4448,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.3271,
    y: 81.4448,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6562,
    y: 81.4448,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.9834,
    y: 81.4448,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.3115,
    y: 81.4448,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.64,
    y: 81.4448,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.968,
    y: 81.4448,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.296,
    y: 81.4448,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.624,
    y: 81.4448,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.951,
    y: 81.4448,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 101.807,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.3271,
    y: 101.807,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6562,
    y: 101.807,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.9834,
    y: 101.807,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.3115,
    y: 101.807,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.64,
    y: 101.807,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.968,
    y: 101.807,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.296,
    y: 101.807,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.624,
    y: 101.807,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.951,
    y: 101.807,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 122.167,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.3271,
    y: 122.167,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6562,
    y: 122.167,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.9834,
    y: 122.167,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.3115,
    y: 122.167,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.64,
    y: 122.167,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.968,
    y: 122.167,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.296,
    y: 122.167,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.624,
    y: 122.167,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.951,
    y: 122.167,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 142.528,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.3271,
    y: 142.529,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6562,
    y: 142.529,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.9834,
    y: 142.529,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.3115,
    y: 142.529,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.64,
    y: 142.529,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.968,
    y: 142.529,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.296,
    y: 142.529,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.624,
    y: 142.529,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.951,
    y: 142.529,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 162.89,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.3271,
    y: 162.89,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6562,
    y: 162.89,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.9834,
    y: 162.89,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.3115,
    y: 162.89,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.64,
    y: 162.89,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.968,
    y: 162.89,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.296,
    y: 162.89,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.624,
    y: 162.89,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.951,
    y: 162.89,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 183.251,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.3271,
    y: 183.251,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6562,
    y: 183.251,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.9834,
    y: 183.251,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.3115,
    y: 183.251,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.64,
    y: 183.251,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.968,
    y: 183.251,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.296,
    y: 183.251,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.624,
    y: 183.251,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.951,
    y: 183.251,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 203.613,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.3271,
    y: 203.614,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6562,
    y: 203.614,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.9834,
    y: 203.614,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.3115,
    y: 203.614,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.64,
    y: 203.614,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.968,
    y: 203.614,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.296,
    y: 203.614,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.624,
    y: 203.614,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.951,
    y: 203.614,
    width: 3.04919,
    height: 3.05419,
    fill: "#6F6F6F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.6befeedf4ba3eb071a4e15925bb7124e.svg";
export { ForwardRef as ReactComponent };